// @greenlight-spec: 19-design-system.md
// @greenlight-spec: 28-it-dashboard-ui.md
import * as React from 'react';

import { AppIconTile } from '@/components/greenlight/AppIconTile';
import { cn, stringToHue } from '@/lib/utils';

export interface AppCoverArtProps {
  name: string;
  slug?: string;
  iconUrl?: string | null;
  /** Icon tile side in px. Default 64. */
  iconSize?: number;
  className?: string;
}

/**
 * Branded cover for an app with no captured screenshot yet: the app's icon (or
 * deterministic monogram) centered on a soft, brand-hued gradient derived from
 * the same seed as the icon tile. Reads as intentional identity art rather than
 * missing data — used by the /apps Grid card and the app-detail hero when
 * `screenshot_urls` is empty. aria-hidden: the surrounding context names the app.
 */
export function AppCoverArt({
  name,
  slug,
  iconUrl,
  iconSize = 64,
  className,
}: AppCoverArtProps): React.JSX.Element {
  const hue = stringToHue(slug ?? name);

  return (
    <div
      aria-hidden
      className={cn('flex h-full w-full items-center justify-center overflow-hidden', className)}
      style={{
        backgroundImage: `linear-gradient(135deg, hsl(${hue} 60% 50% / 0.18), hsl(${(hue + 48) % 360} 60% 50% / 0.08))`,
      }}
    >
      <AppIconTile
        iconUrl={iconUrl}
        name={name}
        slug={slug}
        size={iconSize}
        radius={Math.round(iconSize * 0.28)}
      />
    </div>
  );
}
